import { css } from '@emotion/react';

const locationButtonStyles = {
    locationButton: css({
        width: '44px',
        height: '44px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '8px',
        backgroundColor: '#ffffff',
        cursor: 'pointer',
    }),
    locationButtonIcon: css({
        width: '20px',
        height: '20px',
    }),
};

export default locationButtonStyles;
